module.exports = __webpack_public_path__ + "static/media/logo-instagram.dae3b6d6.svg";